import { createSafeContext } from 'core/Utils';

export type BreakdownType = 'event_dates' | 'season_tickets';

interface EventSalesBreakdownContextType {
  isSingleDate: boolean;
  breakdownType: BreakdownType;
  setBreakdownType: (type: BreakdownType) => void;
  eventCapacity?: number;
}

const [EventSalesBreakdownProvider, useEventSalesBreakdownContext] =
  createSafeContext<EventSalesBreakdownContextType>(
    'EventSalesBreakdownContext was not found in tree'
  );

export { EventSalesBreakdownProvider, useEventSalesBreakdownContext };
